import type { PropsWithChildren, ReactElement } from "react";
import { useMemo } from "react";

import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type { IRangeSelectProps } from "./RangeSelect";
import { RangeSelect } from "./RangeSelect";

export const RangeSelectWithFilter = ({
    optionsMin,
    optionsMax,
    ...props
}: PropsWithChildren<IRangeSelectProps<number>>): ReactElement => {
    const [currentMinValue, currentMaxValue] = props.value;

    const [filteredOptionsMin, filteredOptionsMax] = useMemo((): Array<readonly number[]> => {
        const currentOptionsMax = optionsMax || optionsMin;

        const newOptionsMin = !is.undefined(currentMaxValue)
            ? optionsMin.filter((option: number) => option < currentMaxValue)
            : optionsMin;

        const newOptionsMax = !is.undefined(currentMinValue)
            ? currentOptionsMax.filter((option: number) => option > currentMinValue)
            : currentOptionsMax;

        return [newOptionsMin, newOptionsMax];
    }, [optionsMin, optionsMax, currentMinValue, currentMaxValue]);

    return (
        <RangeSelect<number>
            {...props}
            optionsMin={filteredOptionsMin}
            optionsMax={filteredOptionsMax}
        />
    );
};
